import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Constant, BaseComponent } from '../../../../../infrastructure/common';

import { AuthenticationService } from '../../../../../infrastructure/services/base';

declare var jQuery: any;

@Component({
    moduleId: 'reset-password',
    templateUrl: './reset-password.html',
    styles: [`
    body {background-image: url("assets/images/logistic.jpg");}

     .footer {
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 60px;
            background-color: #90CAF9 !important;
            z-index: -10 !important;
        }

        .mylogin-box {
            max-width: 350px;
        }
    `]
})

export class ResetPasswordComponent implements OnInit, AfterViewInit {
    isLoading = false;
    divMessage = '';
    btnSubmitText = 'Submit';
    isResetted = false;

    newPassword: string;
    confirmNewPassword: string;
    authKey: string;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private authenticationService: AuthenticationService) {
            this.activatedRoute.queryParams.subscribe(params => {
                this.authKey = params['auth'];
            });
        }

    ngOnInit() {

    }

    ngAfterViewInit() {
        jQuery('input[name=txtNewPassword]').focus();
    }

    submit() {
        if (!this.isResetted) {
            this.resetPassword();
        } else {
            this.redirectLogin();
        }
    }

    resetPassword() {
        let self = this;
        this.isLoading = true;

        this.authenticationService.resetPassword(this.authKey, this.newPassword, this.confirmNewPassword)
            .subscribe(
                data => {
                    self.isLoading = false;

                    let message = data;
                    if (message && message.MessageType && message.MessageType.Value) {
                        let additionalInfo = message.AdditionalInformation ? '--' + message.AdditionalInformation : '';
                        self.divMessage = '(' + message.MessageNumber + ') ' + message.Message + additionalInfo;

                        if (message.MessageNumber === 169) {
                            self.btnSubmitText = 'Exit';
                            self.isResetted = true;
                        }
                    }
                    else {
                        self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError);
                    }
                },
                error => {
                    self.isLoading = false;

                    self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
                }
            );
    }

    redirectLogin() {
        this.router.navigate(['login']);
    }

    showMessage(title: string, messageNumber: string, message: string, additionalInfo: string = null) {
        jQuery('#PopupMessageTitle').html(title);
        jQuery('#PopupMessageContent').html('(' + messageNumber + ') ' + message + (additionalInfo ? ' -- ' + additionalInfo : ''));
        jQuery('#PopupMessage').modal('show');
    }
}



// WEBPACK FOOTER //
// ./src/app/views/pages/base/security/login/reset-password.component.ts